// Navbar.js
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';
import './Navbar.css';
import { useMsal } from '@azure/msal-react';
import LogoutButton from './LogoutButton';

function Navbar({ config }) {
    const { accounts } = useMsal();
    const location = useLocation();

    return (
        <div>
            {(accounts.length > 0) && (<React.Fragment>
                <nav role="navigation" aria-label="Main navigation">
                    <ul className="left-nav" role="menubar" aria-label="Primary navigation">
                        <li role="none">
                            <NavLink 
                                to="/" 
                                role="menuitem"
                                activeclassname="active" 
                                style={{ color: 'white', textDecoration: 'none' }}
                                aria-label="Home page"
                            >
                                Home
                            </NavLink>
                        </li>
                        <li role="none">
                            <NavLink 
                                to="/tokenmanager" 
                                role="menuitem"
                                activeclassname="active" 
                                style={{ color: 'white', textDecoration: 'none' }}
                                aria-label="Token Manager page"
                            >
                                Token Manager
                            </NavLink>
                        </li>
                        <li role="none">
                            <NavLink 
                                to="/profile" 
                                role="menuitem"
                                activeclassname="active" 
                                style={{ color: 'white', textDecoration: 'none' }}
                                aria-label="Profile page"
                            >
                                Profile
                            </NavLink>
                        </li>
                        <li role="none">
                            <NavLink 
                                to="/messagelogs" 
                                role="menuitem"
                                activeclassname="active" 
                                style={{ color: 'white', textDecoration: 'none' }}
                                aria-label="View Message Logs page"
                            >
                                View Message Logs
                            </NavLink>
                        </li>
                        <li role="none">
                            <NavLink 
                                to="/uniqerrormsg" 
                                role="menuitem"
                                activeclassname="active" 
                                style={{ color: 'white', textDecoration: 'none' }}
                                aria-label="View Unique Error Logs page"
                            >
                                View Uniq Error Logs
                            </NavLink>
                        </li>
                        <li role="none">
                            <NavLink 
                                to="/apikeymanager" 
                                role="menuitem"
                                activeclassname="active" 
                                style={{ color: 'white', textDecoration: 'none' }}
                                aria-label="API Key Manager page"
                            >
                                ApiKey Manager
                            </NavLink>
                        </li>
                        <li role="none">
                            <NavLink 
                                to="/alertlogs" 
                                role="menuitem"
                                activeclassname="active" 
                                style={{ color: 'white', textDecoration: 'none' }}
                                aria-label="Alert Logs page"
                            >
                                Alert Logs
                            </NavLink>
                        </li>
                        <li role="none">
                            <NavLink 
                                to="/alertconfig" 
                                role="menuitem"
                                activeclassname="active" 
                                style={{ color: 'white', textDecoration: 'none' }}
                                aria-label="Alert Configuration page"
                            >
                                Alert Config
                            </NavLink>
                        </li>
                        <li role="none">
                            <NavLink 
                                to="/messagereport" 
                                role="menuitem"
                                activeclassname="active" 
                                style={{ color: 'white', textDecoration: 'none' }}
                                aria-label="Message Report page"
                            >
                                Message Report
                            </NavLink>
                        </li>
                        {/*<li role="none"><NavLink to="/about" role="menuitem" activeclassname="active" style={{ color: 'white', textDecoration: 'none' }}>About</NavLink></li>*/}
                    </ul>
                    <ul className="right-nav" role="menubar" aria-label="Environment and account controls">
                        <li role="none">
                            <a 
                                href={config.devUrl + location.pathname} 
                                role="menuitem"
                                className={config.enviromentScope === 'dev' ? 'highlighted' : ''} 
                                style={{ color: 'lightblue', marginLeft: '10px', textDecoration: 'none' }}
                                aria-label="Switch to DEV environment"
                                aria-current={config.enviromentScope === 'dev' ? 'true' : undefined}
                            >
                                DEV
                            </a>
                        </li>
                        <li role="none">
                            <a 
                                href={config.qaUrl + location.pathname} 
                                role="menuitem"
                                className={config.enviromentScope === 'qa' ? 'highlighted' : ''} 
                                style={{ color: 'orange', marginLeft: '10px', textDecoration: 'none' }}
                                aria-label="Switch to QA environment"
                                aria-current={config.enviromentScope === 'qa' ? 'true' : undefined}
                            >
                                QA
                            </a>
                        </li>
                        <li role="none">
                            <a 
                                href={config.prodUrl + location.pathname} 
                                role="menuitem"
                                className={config.enviromentScope === 'prod' ? 'highlighted' : ''} 
                                style={{ color: 'lightgreen', marginLeft: '10px', textDecoration: 'none' }}
                                aria-label="Switch to PROD environment"
                                aria-current={config.enviromentScope === 'prod' ? 'true' : undefined}
                            >
                                PROD
                            </a>
                        </li>

                        {accounts.length === 0 ? (
                            <li role="none"></li>
                        ) : (
                            <li role="none"><LogoutButton /></li>
                        )}
                    </ul>
                </nav>
            </React.Fragment>)}
        </div>
    );
}

Navbar.propTypes = {
    config: PropTypes.shape({
        clientId: PropTypes.string.isRequired,
        logMsgApiUrl: PropTypes.string.isRequired,
        authorisedGroups: PropTypes.string.isRequired,
        redirectUri: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        devUrl: PropTypes.string.isRequired,
        qaUrl: PropTypes.string.isRequired,
        prodUrl: PropTypes.string.isRequired,
        enviromentScope: PropTypes.string.isRequired,
    }).isRequired,
};

export default Navbar;
